import React from 'react';
import './DeleteIconButton.css';

/**
 * Icon-only delete button (trash can) for list tables and actions.
 * Use className "list-btn-delete" or "btn-delete" for styling context.
 */
function DeleteIconButton({ onClick, className = 'list-btn-delete', disabled, title = 'Delete', 'aria-label': ariaLabel = 'Delete', children }) {
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
    >
      <span className="delete-icon-btn-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
        </svg>
      </span>
      {children}
    </button>
  );
}

export default DeleteIconButton;
